import uiRouter from '@uirouter/angularjs';

import { ErrorPageModule } from './error/error.module';
import { PinterestModule } from './pinterest/pinterest.module';
import { SiteDesignerModule } from './siteDesigner/siteDesigner.module';
import { StoreCreditModule } from './storeCredit/storeCredit.module';
import { MailChimpModule } from './mailchimp/mailchimp.module';
import { ExternalFulfillerModule } from './externalFulfiller/externalFulfiller.module';
import { AmazonModule } from './amazon/amazon.module';
import { QuickbooksModule } from './quickbooks/quickbooks.module';
import { XeroModule } from './xero/xero.module';

export const PagesModule = angular
    .module('app.pages', [
        uiRouter,
        ErrorPageModule,
        PinterestModule,
        SiteDesignerModule,
        StoreCreditModule,
        MailChimpModule,
        ExternalFulfillerModule,
        AmazonModule,
        QuickbooksModule,
        XeroModule
    ])
    .config(($stateProvider) => {
        function loadLazyModule(transition, moduleName) {
            const $injector = transition.injector().get('$injector');
            return $injector.loadNewModules([moduleName]);
        }

        $stateProvider
            .state({
                parent: 'guest',
                name: 'login.**',
                url: '/login',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "loginPage" */
                        './login/login.module'
                    ).then(module => loadLazyModule(transition, module.LoginModule))
                )
            })
            .state({
                name: 'checkout.**',
                url: '/checkout',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "checkoutPage" */
                        './checkout/checkout.module'
                    ).then(module => loadLazyModule(transition, module.CheckoutModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'dashboard.**',
                url: '/dashboard',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "dashboardPage" */
                        './dashboard/dashboard.module'
                    ).then(module => loadLazyModule(transition, module.DashboardModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'customer.**',
                url: '/customer',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "customersPage" */
                        './customers/customers.module'
                    ).then(module => loadLazyModule(transition, module.CustomersModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'postage.**',
                url: '/postage',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "postagePage" */
                        './postage/postage.module'
                    ).then(module => loadLazyModule(transition, module.PostageModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'pages.**',
                url: '/pages',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "pagesPage" */
                        './pages/pages.module'
                    ).then(module => loadLazyModule(transition, module.PagesModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'appstore2.**',
                url: '/appstore2',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "appStorePage2" */
                        './appStore2/appStore2.module'
                    ).then(module => loadLazyModule(transition, module.AppStoreModule2))
                )
            })
            .state({
                parent: 'auth',
                name: 'category.**',
                url: '/category',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "categoryOldPage" */
                        './categories-old/categoriesOld.module'
                    ).then(module => loadLazyModule(transition, module.CategoriesOldModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'categories.**',
                url: '/categories',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "categoryPage" */
                        './categories/categories.module'
                    ).then(module => loadLazyModule(transition, module.CategoriesModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'myAccount.**',
                url: '/myaccount',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "myAccountPage" */
                        './myAccount/myAccount.module'
                    ).then(module => loadLazyModule(transition, module.MyAccountModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'discounts.**',
                url: '/discounts',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "discountsPage" */
                        './discounts/discounts.module'
                    ).then(module => loadLazyModule(transition, module.DiscountsModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'fulfillers.**',
                url: '/fulfillers',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "fulfillersPage" */
                        './fulfillers/fulfillers.module'
                    ).then(module => loadLazyModule(transition, module.FulfillersModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'order.**',
                url: '/order',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "orderPage" */
                        './orders/orders.module'
                    ).then(module => loadLazyModule(transition, module.OrdersModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'editstore.**',
                url: '/editstore',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "editstorePage" */
                        './editstore/editstore.module'
                    ).then(module => loadLazyModule(transition, module.EditStoreModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'product.**',
                url: '/product',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "productsPage" */
                        './products/products.module'
                    ).then(module => loadLazyModule(transition, module.ProductsModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'settings.**',
                url: '/settings',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "settingsPage" */
                        './settings/settings.module'
                    ).then(module => loadLazyModule(transition, module.SettingsModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'analytics.**',
                url: '/analytics',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "analyticsPage" */
                        './analytics/analytics.module'
                    ).then(module => loadLazyModule(transition, module.AnalyticsModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'facebookPixel.**',
                url: '/facebookpixel',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "facebookPixelPage" */
                        './facebookPixel/facebookPixel.module'
                    ).then(module => loadLazyModule(transition, module.FacebookPixelModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'fullstory.**',
                url: '/fullstory',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "fullstoryPage" */
                        './fullstory/fullstory.module'
                    ).then(module => loadLazyModule(transition, module.FullstoryModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'googleAnalytics.**',
                url: '/googleanalytics',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "googleAnalyticsPage" */
                        './googleAnalytics/googleAnalytics.module'
                    ).then(module => loadLazyModule(transition, module.GoogleAnalyticsModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'privy.**',
                url: '/privy',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "privyPage" */
                        './privy/privy.module'
                    ).then(module => loadLazyModule(transition, module.PrivyModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'chat.**',
                url: '/chat',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "chatPage" */
                        './chat/chat.module'
                    ).then(module => loadLazyModule(transition, module.ChatModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'zapier.**',
                url: '/zapier',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "zapierPage" */
                        './zapier/zapier.module'
                    ).then(module => loadLazyModule(transition, module.ZapierModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'yotpo.**',
                url: '/yotpo',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "yotpoPage" */
                        './yotpo/yotpo.module'
                    ).then(module => loadLazyModule(transition, module.YotpoModule))
                )
            })
            .state({
                parent: 'auth',
                name: 'avalara',
                url: '/avalara'
            })
            .state({
                parent: 'auth',
                name: 'cancelStore.**',
                url: '/cancel-store',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "cancelStorePage" */
                        './cancelStore/cancelStore.module'
                    ).then(module => loadLazyModule(transition, module.CancelStoreModule))
                )
            })
            .state({
                name: 'delinquentAccount.**',
                url: '/myaccount/pastdue',
                parent: 'auth',
                template: '<delinquent-account></delinquent-account>',
                data: {
                    showSideNavigationMenu: false
                },
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "delinquentAccountPage" */
                        '../admin/pages/myAccount/DelinquentAccount/DelinquentAccount.ng'
                    ).then(module => loadLazyModule(transition, module.DelinquentAccountModule))
                )
            })
            .state({
                name: 'onHold.**',
                url: '/onhold',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "onHoldPage" */
                        './onHold'
                    ).then(module => loadLazyModule(transition, module.OnHoldPage))
                )
            })
            .state({
                name: 'siteTagging.**',
                url: '/site-tagging',
                lazyLoad: transition => (
                    import(
                        /*  webpackChunkName: "siteTaggingPage" */
                        './siteTagging'
                    ).then(module => loadLazyModule(transition, module.SiteTaggingPage))
                )
            });
    }).name;



// WEBPACK FOOTER //
// ./src/app/pages/pages.module.js